import Repository from './Repository'

const resource = '/twilio'

export default {
  getInfoThreadAcd () {
    return Repository.get(`${resource}/acd`)
  },
  async updateACD (statusACD) {
    try {
      return await Repository.post(`${resource}/acd`, { data: statusACD })
    } catch (e) {
      return this.setErrors(e)
    }
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
